import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LP_UI_CONFIG } from '../core/tokens';

@Injectable({
  providedIn: 'root',
})
export class ServiceConditionApi {
  private http = inject(HttpClient);
  private readonly cfg = inject(LP_UI_CONFIG);

  dismissBannerNotification(payload: any) {
    return this.http.post<void>(`${this.cfg.host}api/dismiss_banner_notification`, payload);
  }

  acceptServiceCondition(payload: any) {
    return this.http.post<void>(`${this.cfg.host}api/accept_service_condition`, payload);
  }

  getBannerNotifications() {
    return this.http.get<any>(`${this.cfg.host}api/banner_notifications`);
  }
}
